/* Vegas Crystal Healings: site-wide magic (preview).
   1) Gold frames: 3D tilt, draw-in when scrolled into view.
   2) Floating gold dust in the homepage welcome area only.
   3) Fairy-dust sparkle trail behind the fairy pointer on every page (computers only).
   Everything switches off for visitors who ask their device to reduce motion. */
(function () {
  window.vchMagicReady = true;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = document.documentElement.classList.contains('shopify-design-mode');
  var finePointer = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- Gold frames ---------- */
  function initFrames() {
    var frames = document.querySelectorAll('[data-holo]');
    if (!frames.length) return;
    function finish(h) { h.classList.add('is-drawn'); setTimeout(function () { h.classList.add('is-done'); }, 1950); }
    if (reduce || design || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(frames, function (h) { h.classList.add('is-drawn', 'is-done'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); finish(e.target); } });
      }, { threshold: 0.25 });
      Array.prototype.forEach.call(frames, function (h) { io.observe(h); });
    }
    if (reduce) return;
    Array.prototype.forEach.call(frames, function (h) {
      var raf = 0;
      function move(e) {
        var r = h.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          h.classList.add('is-tilting');
          h.style.setProperty('--rx', ((x - .5) * 14).toFixed(2) + 'deg');
          h.style.setProperty('--ry', ((.5 - y) * 10).toFixed(2) + 'deg');
          h.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
          h.style.setProperty('--my', (y * 100).toFixed(1) + '%');
        });
      }
      function leave() {
        cancelAnimationFrame(raf); h.classList.remove('is-tilting');
        h.style.setProperty('--rx', '0deg'); h.style.setProperty('--ry', '0deg');
        h.style.setProperty('--mx', '50%'); h.style.setProperty('--my', '30%');
      }
      h.addEventListener('pointermove', function (e) { if (e.pointerType === 'mouse') move(e); });
      h.addEventListener('pointerleave', leave);
    });
  }

  // Pre-drawn sprites: a soft gold glow dot and a four-point gold star
  function sprite(draw, s) { var c = document.createElement('canvas'); c.width = c.height = s; draw(c.getContext('2d'), s); return c; }
  var DOT, STAR;
  function makeSprites() {
    if (DOT) return;
    DOT = sprite(function (g, s) {
    var r = s / 2, gr = g.createRadialGradient(r, r, 0, r, r, r);
    gr.addColorStop(0, 'rgba(255,248,225,1)'); gr.addColorStop(.25, 'rgba(236,200,120,.95)');
    gr.addColorStop(.6, 'rgba(205,160,70,.35)'); gr.addColorStop(1, 'rgba(205,160,70,0)');
    g.fillStyle = gr; g.fillRect(0, 0, s, s);
  }, 32);
  STAR = sprite(function (g, s) {
    var r = s / 2, gr = g.createRadialGradient(r, r, 0, r, r, r * .55);
    gr.addColorStop(0, 'rgba(240,205,130,.55)'); gr.addColorStop(1, 'rgba(240,205,130,0)');
    g.fillStyle = gr; g.fillRect(0, 0, s, s);
    g.translate(r, r); g.fillStyle = '#FFF3D0'; g.beginPath();
    var a = s * .48, b = s * .07;
    g.moveTo(0, -a); g.quadraticCurveTo(b, -b, a, 0); g.quadraticCurveTo(b, b, 0, a);
    g.quadraticCurveTo(-b, b, -a, 0); g.quadraticCurveTo(-b, -b, 0, -a); g.fill();
    g.fillStyle = 'rgba(214,170,80,.9)'; g.beginPath(); g.arc(0, 0, s * .06, 0, Math.PI * 2); g.fill();
  }, 48);
  }

  /* ---------- Floating gold dust: only inside the homepage welcome area ---------- */
  function initDust() {
    if (reduce || design) return;
    var host = document.querySelector('[data-vch-dust], .vch > section[aria-label="Welcome"]');
    if (!host) return;
    makeSprites();
    var cv = document.createElement('canvas');
    cv.className = 'vch-dust'; cv.setAttribute('aria-hidden', 'true');
    var ctx = cv.getContext('2d'); if (!ctx) return;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    host.appendChild(cv);
    var W = 0, H = 0, DPR = 1;
    function size() {
      DPR = Math.min(window.devicePixelRatio || 1, 2);
      W = host.clientWidth; H = host.clientHeight;
      cv.width = Math.round(W * DPR); cv.height = Math.round(H * DPR);
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    }
    size();
    if ('ResizeObserver' in window) new ResizeObserver(size).observe(host); else window.addEventListener('resize', size);

    var dust = [];
    var target = Math.round(Math.min(46, Math.max(14, (W * H) / 26000)));
    function newMote(anywhere) {
      return {
        x: Math.random() * W, y: anywhere ? Math.random() * H : H + 10,
        r: 2.6 + Math.random() * 4.6, vy: .12 + Math.random() * .32, sway: Math.random() * Math.PI * 2,
        sw: .2 + Math.random() * .5, tw: Math.random() * Math.PI * 2, ts: .015 + Math.random() * .03,
        star: Math.random() < .14
      };
    }
    for (var i = 0; i < target; i++) dust.push(newMote(true));

    var visible = true, pageShown = !document.hidden, rafId = 0;
    function kick() { if (!rafId && visible && pageShown) rafId = requestAnimationFrame(tick); }
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { visible = es[0].isIntersecting; kick(); }).observe(host);
    document.addEventListener('visibilitychange', function () { pageShown = !document.hidden; kick(); });
    function tick() {
      rafId = 0;
      if (!visible || !pageShown) return;
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < dust.length; i++) {
        var m = dust[i];
        m.y -= m.vy; m.sway += .008; m.tw += m.ts;
        var x = m.x + Math.sin(m.sway) * 14 * m.sw;
        if (m.y < -12) { dust[i] = newMote(false); continue; }
        var a = .28 + (Math.sin(m.tw) * .5 + .5) * .55;
        ctx.globalAlpha = a;
        var s = m.star ? m.r * 3.2 : m.r * 2;
        ctx.drawImage(m.star ? STAR : DOT, x - s / 2, m.y - s / 2, s, s);
      }
      ctx.globalAlpha = 1;
      kick();
    }
    kick();
  }

  /* ---------- Fairy-dust trail behind the fairy pointer: every page, computers only ---------- */
  function initTrail() {
    if (reduce || design || !finePointer) return;
    // Richer gold sparkles so the trail shows on light pages as well as dark ones
    var TDOT = sprite(function (g, s) {
      var r = s / 2, gr = g.createRadialGradient(r, r, 0, r, r, r);
      gr.addColorStop(0, 'rgba(255,240,200,1)'); gr.addColorStop(.3, 'rgba(226,182,92,1)');
      gr.addColorStop(.62, 'rgba(184,137,47,.45)'); gr.addColorStop(1, 'rgba(184,137,47,0)');
      g.fillStyle = gr; g.fillRect(0, 0, s, s);
    }, 32);
    var TSTAR = sprite(function (g, s) {
      var r = s / 2, gr = g.createRadialGradient(r, r, 0, r, r, r * .6);
      gr.addColorStop(0, 'rgba(240,200,110,.6)'); gr.addColorStop(1, 'rgba(240,200,110,0)');
      g.fillStyle = gr; g.fillRect(0, 0, s, s);
      g.translate(r, r); g.beginPath();
      var a = s * .48, b = s * .08;
      g.moveTo(0, -a); g.quadraticCurveTo(b, -b, a, 0); g.quadraticCurveTo(b, b, 0, a);
      g.quadraticCurveTo(-b, b, -a, 0); g.quadraticCurveTo(-b, -b, 0, -a);
      g.fillStyle = '#E9C26A'; g.fill(); g.lineWidth = s * .03; g.strokeStyle = 'rgba(156,113,36,.9)'; g.stroke();
      g.fillStyle = '#FFF6DC'; g.beginPath(); g.arc(0, 0, s * .07, 0, Math.PI * 2); g.fill();
    }, 48);
    var cv = document.createElement('canvas');
    cv.className = 'vch-trail'; cv.setAttribute('aria-hidden', 'true');
    var ctx = cv.getContext('2d'); if (!ctx) return;
    document.body.appendChild(cv);
    var W = 0, H = 0, DPR = 1;
    function size() {
      DPR = Math.min(window.devicePixelRatio || 1, 2);
      W = window.innerWidth; H = window.innerHeight;
      cv.width = Math.round(W * DPR); cv.height = Math.round(H * DPR);
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    }
    size(); window.addEventListener('resize', size);
    var trail = [], rafId = 0, lx = -1, ly = -1;
    window.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      var dx = e.clientX - lx, dy = e.clientY - ly;
      if (lx >= 0 && dx * dx + dy * dy < 64) return;
      lx = e.clientX; ly = e.clientY;
      var n = 1 + (Math.random() < .5 ? 1 : 0);
      for (var k = 0; k < n && trail.length < 90; k++) {
        trail.push({
          x: e.clientX + (Math.random() - .5) * 10, y: e.clientY + (Math.random() - .5) * 10,
          vx: (Math.random() - .5) * .7, vy: .25 + Math.random() * .7, life: 0,
          max: 38 + Math.random() * 30, r: 5 + Math.random() * 9, star: Math.random() < .45, rot: Math.random() * 6.28
        });
      }
      if (!rafId) rafId = requestAnimationFrame(tick);
    }, { passive: true });
    document.addEventListener('mouseleave', function () { lx = ly = -1; });
    function tick() {
      rafId = 0;
      ctx.clearRect(0, 0, W, H);
      for (var j = trail.length - 1; j >= 0; j--) {
        var t = trail[j]; t.life++;
        if (t.life > t.max) { trail.splice(j, 1); continue; }
        t.x += t.vx; t.y += t.vy; t.vy *= .985;
        var p = t.life / t.max, al = p < .15 ? p / .15 : 1 - (p - .15) / .85;
        var sz = t.r * (1 - p * .5) * (t.star ? 2.4 : 1.6);
        ctx.globalAlpha = Math.max(0, al) * .95;
        if (t.star) {
          ctx.save(); ctx.translate(t.x, t.y); ctx.rotate(t.rot + p); ctx.drawImage(TSTAR, -sz / 2, -sz / 2, sz, sz); ctx.restore();
        } else ctx.drawImage(TDOT, t.x - sz / 2, t.y - sz / 2, sz, sz);
      }
      ctx.globalAlpha = 1;
      if (trail.length) rafId = requestAnimationFrame(tick);
    }
  }

  function start() { initFrames(); initDust(); initTrail(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
